<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	// Design system components
	import { Row, Col, Text, Loader, ParameterCardV2 } from '@Shelly/shelly-design-system';
	// Helpers
	import { isThreeEM, real_id } from '../../helpers/interface_helpers';
	import CacheStatisticRequest from '../Chart/chart_cache_helper';
	import { dateFormat } from '../../helpers/date_helper';
	import { convert } from '../../helpers/utilities';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	// Types
	import type { Device } from '../../types/Device';

	export let device: Device;

	const id = real_id(device.id);
	let peakPowerData: {
		live: { value: string; time: string }[];
		avg5: { value: string; time: string }[];
	} = null;

	const mapPowerPickData = (i: { c: number; r: number; t: number }) => {
		const value = i.c >= Math.abs(i.r) ? i.c : i.r;
		return {
			value: convert(value, 'W'),
			time: i.t > 0 ? dateFormat(i.t * 1000, 'H:i:s d/m') : '',
		};
	};

	const getPeakStatistics = async () => {
		const res = await CacheStatisticRequest.getData(
			'/v2/devices/get/',
			{
				//@ts-ignore
				ids: [id],
			},
			undefined,
			false,
			true,
		);
		if (res?.[0]?.peakPower) {
			const peakPower = res?.[0]?.peakPower;
			peakPowerData = {
				live: peakPower.live.map((i) => (i = mapPowerPickData(i))),
				avg5: peakPower.avg5.map((i) => (i = mapPowerPickData(i))),
			};
		}
		return peakPowerData;
	};
</script>

{#if $devices[id]?.cloud_options?.measure_peak_power}
	<div class="mb-s">
		{#await getPeakStatistics()}
			<div class="d-flex justify-content-center">
				<Loader />
			</div>
		{:then peakPowerData}
			{#if peakPowerData}
				<Text styleType="body-small" class="mb-s text-capitalize"
					>{$format('title_pick_power', { default: 'Highest peak energy' })}</Text
				>
				{#if isThreeEM(device?.type) && device?.mode != 'monophase'}
					<Row>
						{#each peakPowerData.live as channel}
							<Col>
								<ParameterCardV2
									class="mb-s"
									backgroundColor="--color-0"
									size="s"
									title={channel.value}
									description={channel.time}
								/>
							</Col>
						{/each}
					</Row>
				{:else}
					<ParameterCardV2
						backgroundColor="--color-0"
						size="s"
						class="mb-s"
						title={peakPowerData.live[device.channel]?.value}
						description={peakPowerData?.live[device.channel]?.time}
					/>
				{/if}
				<Text styleType="body-small" class="mb-s text-capitalize"
					>{$format('title_pick_power_avg', {
						default: 'Peak energy average',
					})}</Text
				>
				{#if isThreeEM(device?.type) && device?.mode != 'monophase'}
					<Row>
						{#each peakPowerData.avg5 as channel}
							<Col>
								<ParameterCardV2
									backgroundColor="--color-0"
									class="mb-s"
									size="s"
									title={channel.value}
									description={channel.time}
								/>
							</Col>
						{/each}
					</Row>
				{:else}
					<ParameterCardV2
						backgroundColor="--color-0"
						size="s"
						class="mb-s"
						title={peakPowerData.avg5[device.channel]?.value}
						description={peakPowerData?.avg5[device.channel]?.time}
					/>
				{/if}
			{/if}
		{/await}
	</div>
{/if}
